// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC, useEffect, useMemo, useState } from "react";
import { css } from "styled-components";

const enum fields {
    formId = "formId",
    showBackground = "showBackground",
}

export interface HubSpotEmbedProps extends WidgetProps {
    fields: {
        [fields.formId]: string;
        [fields.showBackground]: boolean;
    };
}

export interface HubSpotEmbedStyles {
    wrapper?: InjectableCss;
}

const hubSpotEmbedStyles: HubSpotEmbedStyles = {
    wrapper: {
        css: css`
            width: 100%;
        `,
    },
};

const HubSpotEmbed: FC<HubSpotEmbedProps> = ({ id, fields: { formId, showBackground } }) => {
    const [api, setApi] = useState(typeof window !== "undefined" ? (window as any).hbspt : undefined);
    const portalId = useSettingsCollection().customSettings.hubSpotPortalId;
    const targetId = `hubspot-${id}`;

    const styles = useMemo(() => {
        if (!showBackground) {
            return hubSpotEmbedStyles;
        }

        return mergeProps<HubSpotEmbedStyles>(hubSpotEmbedStyles, {
            wrapper: {
                css: css`
                    background-color: ${getColor("common.accent")};
                    ${breakpointValues(pxToRemArray([20, 30, null, 40]), "padding")}
                `,
            },
        });
    }, [hubSpotEmbedStyles, showBackground]);

    useEffect(() => {
        if (!api) {
            const script = document.createElement("script");

            script.type = "text/javascript";
            script.src = "//js.hsforms.net/forms/embed/v2.js";

            script.addEventListener("load", () => setApi((window as any).hbspt));

            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        }
    }, [api]);

    useEffect(() => {
        if (api && formId && portalId) {
            api.forms.create({
                region: "na1",
                portalId,
                formId,
                target: `#${targetId}`,
            });
        }
    }, [api, id, formId, portalId]);

    return <StyledWrapper id={targetId} {...styles.wrapper}></StyledWrapper>;
};

const widgetModule: WidgetModule = {
    component: HubSpotEmbed,
    definition: {
        group: "Basic",
        displayName: "HubSpot Embed",
        icon: "hubspot fa-brands",
        fieldDefinitions: [
            {
                name: fields.formId,
                editorTemplate: "TextField",
                fieldType: "Contextual",
                defaultValue: "",
            },
            {
                name: fields.showBackground,
                editorTemplate: "CheckboxField",
                fieldType: "Contextual",
                defaultValue: false,
            },
        ],
    },
};

export default widgetModule;
